const CHUNK_RELOAD_FLAG_KEY = 'chunk-reload-attempted';

/**
 * Reloads the page at most once per browser session when a deployment-related
 * chunk load failure has been detected. Uses sessionStorage to prevent loops.
 *
 * @returns {boolean} true if a reload was triggered; false if already attempted
 */
export function reloadOnChunkFailure() {
	if (sessionStorage.getItem(CHUNK_RELOAD_FLAG_KEY) != null) {
		return false;
	}

	sessionStorage.setItem(CHUNK_RELOAD_FLAG_KEY, '1');
	window.location.reload();
	return true;
}

/**
 * Clears the session flag so a future deployment-related reload can occur.
 */
export function clearChunkReloadFlag() {
	sessionStorage.removeItem(CHUNK_RELOAD_FLAG_KEY);
}
